module.exports = __webpack_public_path__ + "static/media/156.4310f03a.jpg";